/* Test gratuit 10 questions (3 choix). Aucune donnée ne quitte le navigateur.
   Résultat gardé dans localStorage « rb_result » puis ouverture de la page Résultat.
   ?a1=0|1|2 : réponse donnée à la question 1 depuis le héros de l'accueil. */
(function () {
  'use strict';
  var root = document.getElementById('rb-quiz-root');
  if (!root) return;
  var QUIZ, T;
  try {
    QUIZ = JSON.parse(document.getElementById('rb-questions').textContent);
    T = JSON.parse(document.getElementById('rb-quiz-strings').textContent);
  } catch (e) { return; }

  var es = root.getAttribute('data-lang') === 'es';
  var resultUrl = root.getAttribute('data-result-url');
  var reportEmail = root.getAttribute('data-report-email');
  var box = document.getElementById('rb-quiz');
  var bar = document.getElementById('rb-quiz-next');
  var count = document.getElementById('rb-q-count');
  var progress = document.getElementById('rb-q-progress');
  var progressBar = document.getElementById('rb-q-progressbar');
  var Voice = window.RbVoice;
  var i = 0, answers = [], slow = false, answered = false;
  var LETTERS = 'ABC';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function el(tag, attrs, text) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k]; else n.setAttribute(k, attrs[k]);
    });
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function setProgress(done) {
    progress.style.width = (done / QUIZ.length * 100) + '%';
    progressBar.setAttribute('aria-valuenow', String(done));
  }
  function readText(item) {
    return item.q + ' ... ' + item.opts.map(function (o, k) { return LETTERS[k] + '. ' + o; }).join(' ... ');
  }

  function render() {
    var item = QUIZ[i];
    answered = false;
    if (Voice) Voice.stop();
    count.textContent = T.count.replace('%n', i + 1).replace('%t', QUIZ.length);
    setProgress(i);
    box.textContent = '';

    var topic = el('div', { class: 'rb-topic' });
    topic.appendChild(el('span', { class: 'rb-pill' }, item.topic[es ? 1 : 0]));
    box.appendChild(topic);

    var h = el('h1', { class: 'rb-question', lang: 'en-US', id: 'rb-q-text', tabindex: '-1' }, item.q);
    box.appendChild(h);

    var tools = el('div', { class: 'rb-tools' });
    var bListen = el('button', { type: 'button', class: 'rb-listen', 'aria-pressed': 'false' });
    bListen.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M11 5L6 9H3v6h3l5 4V5z"/><path d="M15.5 8.5a5 5 0 010 7M18.5 5.5a9 9 0 010 13"/></svg>';
    bListen.appendChild(document.createTextNode(T.listen));
    var bSlow = el('button', { type: 'button', class: 'rb-listen rb-slow', 'aria-pressed': String(slow) }, '🐢 ' + T.slower);
    tools.appendChild(bListen); tools.appendChild(bSlow);
    box.appendChild(tools);
    var noVoice = el('p', { class: 'rb-err', hidden: '' }, T.unsupported);
    box.appendChild(noVoice);

    if (es && item.kw && item.kw.length) {
      var kw = el('div', { class: 'rb-keywords' });
      kw.appendChild(el('span', { class: 'rb-small rb-muted', style: 'width:100%' }, T.keywords));
      item.kw.forEach(function (k) {
        var s = el('span', { class: 'rb-kw' });
        s.appendChild(el('b', { lang: 'en-US' }, k[0]));
        s.appendChild(document.createTextNode(' = ' + k[1]));
        kw.appendChild(s);
      });
      box.appendChild(kw);
    }

    var opts = el('div', { class: 'rb-options', role: 'group', 'aria-label': T.answers, 'aria-describedby': 'rb-q-text' });
    item.opts.forEach(function (o, k) {
      var b = el('button', { type: 'button', class: 'rb-option', 'data-k': String(k) });
      b.appendChild(el('span', { class: 'rb-letter', 'aria-hidden': 'true' }, LETTERS[k]));
      b.appendChild(el('span', { lang: 'en-US' }, o));
      b.addEventListener('click', function () { choose(k); });
      opts.appendChild(b);
    });
    box.appendChild(opts);
    box.appendChild(el('div', { id: 'rb-feedback', 'aria-live': 'polite' }));

    bar.disabled = true;
    bar.textContent = T.choose;

    bListen.addEventListener('click', function () {
      if (!Voice || !Voice.ok) { noVoice.hidden = false; return; }
      if (bListen.classList.contains('rb-on')) { Voice.stop(); bListen.classList.remove('rb-on'); bListen.setAttribute('aria-pressed', 'false'); return; }
      bListen.classList.add('rb-on'); bListen.setAttribute('aria-pressed', 'true');
      Voice.speak(readText(item), slow ? 0.7 : 0.92, function () { bListen.classList.remove('rb-on'); bListen.setAttribute('aria-pressed', 'false'); });
    });
    bSlow.addEventListener('click', function () { slow = !slow; bSlow.setAttribute('aria-pressed', String(slow)); });

    if (i > 0) { h.focus({ preventScroll: true }); window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); }
  }

  function choose(k) {
    if (answered) return;
    answered = true;
    if (Voice) Voice.stop();
    var item = QUIZ[i], good = k === item.a;
    answers.push({ id: item.id, k: k, good: good });
    box.querySelectorAll('.rb-option').forEach(function (b, n) {
      b.disabled = true;
      if (n === item.a) { b.classList.add('rb-correct'); b.setAttribute('aria-label', T.correctAria + ': ' + LETTERS[n] + '. ' + item.opts[n]); }
      if (n === k && !good) b.classList.add('rb-wrong');
    });
    var fb = el('div', { class: 'rb-feedback ' + (good ? 'rb-ok' : 'rb-ko') });
    fb.appendChild(el('h2', { class: 'rb-h3' }, good ? T.correct : T.wrong.replace('%l', LETTERS[item.a])));
    fb.appendChild(el('p', { style: 'margin:0' }, item.ex[es ? 1 : 0]));
    fb.appendChild(el('p', { class: 'rb-ref' }, T.source + ' ' + item.ref));
    var rp = el('p', { class: 'rb-small', style: 'margin:8px 0 0' });
    var rb = el('a', { class: 'rb-report-err', href: 'mailto:' + reportEmail + '?subject=' + encodeURIComponent('Error report ' + item.id) }, '⚑ ' + T.report);
    rb.addEventListener('click', function () { setTimeout(function () { rp.textContent = T.reportThanks; }, 300); });
    rp.appendChild(rb);
    fb.appendChild(rp);
    document.getElementById('rb-feedback').appendChild(fb);

    setProgress(i + 1);
    bar.disabled = false;
    bar.textContent = i < QUIZ.length - 1 ? T.next : T.seeScore;
    bar.focus({ preventScroll: true });
    fb.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
  }

  bar.addEventListener('click', function () {
    if (!answered) return;
    if (i < QUIZ.length - 1) { i++; render(); return; }
    var topics = {};
    answers.forEach(function (a, n) {
      var t = QUIZ[n].topic, key = t[0];
      topics[key] = topics[key] || { en: t[0], es: t[1], miss: 0, total: 0 };
      topics[key].total++;
      if (!a.good) topics[key].miss++;
    });
    var score = answers.filter(function (a) { return a.good; }).length;
    try { localStorage.setItem('rb_result', JSON.stringify({ score: score, total: QUIZ.length, topics: topics, at: Date.now() })); } catch (e) {}
    location.href = resultUrl;
  });

  render();

  // Réponse donnée dans le héros de l'accueil
  try {
    var a1 = new URLSearchParams(location.search).get('a1');
    if (a1 === '0' || a1 === '1' || a1 === '2') choose(parseInt(a1, 10));
  } catch (e) {}
})();
